import { AsyncUtils } from './async-utils';

export class RetryUtils {

  static async async<T>(func: () => Promise<T>,
                        maxAttempts = 3,
                        retryable: (error: unknown) => boolean = () => true): Promise<T> {
    let attempt = 1;
    while (attempt <= maxAttempts) {
      try {
        return await func();
      } catch (e) {
        attempt++;
        if (attempt > maxAttempts || !retryable(e)) {
          throw e;
        } else {
          console.log(e);
          await AsyncUtils.sleep(500 * attempt);
        }
      }
    }
    throw Error(`All ${attempt} attempts failed`);
  }

}
